const setupMockUnity = ({
  unityInstance,
  buildReceiver,
  bodyDimensions
}) => {
  unityInstance.SendMessage = (sceneObject, methodName, data) => {
    console.log('sending message', sceneObject, methodName, data)
    if (sceneObject === buildReceiver) {
      let payload
      switch (methodName) {
        case 'SendFullBodyDimensionsUnity':
          payload = JSON.stringify({
            requestKey: data,
            bodyDimensions: bodyDimensions()
          })
          window.onFullBodyDimensionsJs(payload)
          window.onSceneOpened('pose-character')
          break
      }
    }
  }
  window.onSceneOpened('body-build')
}

export default setupMockUnity
